module.exports = __webpack_public_path__ + "static/media/Helping Others (Expressing Limits) V034.f8055c43.vtt";